import request from '@/utils/request';
// 规则列表
export const getLevelList = (params: any) =>
  request({
    url: 'EvaluateTags/levelList',
    method: 'get',
    params
  });

// 规则下 设置评价标签
export const setEvaluate = (data: any) =>
  request({
    url: 'EvaluateTags/setEvaluate',
    method: 'POST',
    data
  });

// 评价标签列表
export const getEvaluateTagList = (params: any) =>
  request({
    url: 'EvaluateTags/tagsList',
    method: 'get',
    params
  });

// 添加评价标签
export const addEvaluateTag = (data: any) =>
  request({
    url: 'EvaluateTags/tags',
    method: 'POST',
    data
  });

// 删除评价标签
export const deleteEvaluateTag = (data: any) =>
  request({
    url: 'EvaluateTags/tags',
    method: 'DELETE',
    data
  });

// 编辑评价标签
export const modifyEvaluateTag = (data: any) =>
  request({
    url: 'EvaluateTags/tags',
    method: 'PUT',
    data
  });

// 评价下 设置规则
export const setLevel = (data: any) =>
  request({
    url: 'EvaluateTags/setLevel',
    method: 'POST',
    data
  });

// 特殊情况  随后处理  放在system.ts中  死活报错 is not a function
export const getWechatConfig = (params: any) =>
  request({
    url: 'System/wxConfig',
    method: 'get',
    params
  });
export const configWechat = (data: any) =>
  request({
    url: 'System/wxConfig',
    method: 'PUT',
    data
  });

// 钉钉配置
export const getDingdingConfig = (params: any) =>
  request({
    url: 'System/ddConfig',
    method: 'get',
    params
  });

export const configDingding = (data: any) =>
  request({
    url: 'System/ddConfig',
    method: 'PUT',
    data
  });

// 订单配置
export const getOrderProcess = (params: any) =>
  request({
    url: 'System/orderProcess',
    method: 'get',
    params
  });

export const configOrderProcess = (data: any) =>
  request({
    url: 'System/orderProcess',
    method: 'PUT',
    data
  });
